/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { BaseCheckoutState } from '../checkout-state/base-checkout-state';
import { ICheckoutState } from '../state-interfaces/i-checkout-state';
import createGlobalStateDataAction from './global-state-data-action';

export default createGlobalStateDataAction<ICheckoutState>('CHECKOUTSTATE', BaseCheckoutState);
